
import { Component, Mixins, Prop } from "vue-property-decorator"
import Common from '../mixins/common';
import { getDoc } from "firebase/firestore";
import ModalEventDetails from "@/components/ModalEventDetails.vue"
import { EventData } from "@/common-datatypes";
import ModalAlert from "@/components/ModalAlert.vue"
import ModalEditEvent from "@/components/ModalEditEvent.vue"

@Component({
  components: {
    ModalEventDetails,
    ModalAlert,
    ModalEditEvent
  }
})

export default class EventObject extends Mixins(Common) {
  @Prop({type: String, default: ''}) private eventId?: string

  isLoading: (boolean | string) = false

  modalEventProps = {
    isLoading: false,
    isShow: false,
    errorMessage: '',
    confirmText: 'event.add',
    theEventData: {} as EventData,
  }

  modalEventEditProps = {
    isLoading: false,
    isShow: false,
    errorMessage: '',
    confirmText: 'event.add',
    theEventData: {} as EventData,
  }

  modalAlertProps = {
    title: '',
    message: '',
    isShow: false,
  }

  async created(){
    try{
      this.isLoading = true
      this.$store.commit("setLoading",true)

      if(this.eventId){
        const eventDocId = this.eventId
         const eventDoc = await getDoc(this.$getEventDocRef(eventDocId))

        if(eventDoc.exists()){
          const event = eventDoc.data() as EventData
          if(event){
            this.modalEventProps = {
              ...this.modalEventProps,
              theEventData: event,
              isShow: true
            }
            this.modalEventEditProps = {
              ...this.modalEventEditProps,
              theEventData: event,
            }
          }
        }else{
          this.showAlertNotFound()
        }
      }else{
        this.showAlertNotFound()
      }
    }catch(error){
      this.showAlertNotAuthorized()
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  showAlertNotAuthorized(){
    this.modalAlertProps = {
        title: this.$t('message.notAuthorized') as string,
        message: this.$t('event.notAuthorized') as string,
        isShow: true
      }
  }

  showAlertNotFound(){
    this.modalAlertProps = {
      title: this.$t('message.notFound') as string,
      message: this.$t('event.notFound') as string,
      isShow: true
    }
  }

   onClose() {
    this.modalAlertProps.isShow = false
    this.modalEventProps.isShow = false
    this.modalEventEditProps.isShow = false
    this.$emit("onClose", true)
  }

  openEditModal(){
    if(! this.isStaff){
      this.showAlertNotAuthorized()
      return
    }

    this.modalAlertProps.isShow = false
    this.modalEventProps.isShow = false
    this.modalEventEditProps.isShow = true
  }

  get isStaff(){
    return this.$store.getters.isStaff
  }

  destroyed() {
    //this.$unsubscriber(this.observers)
  }
}
